/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */
import React from 'react';

export const SectionHeader = ({ Icon, title, subtitle, color = 'var(--wl-primary)' }) => (
  <div className="flex items-center gap-3 mb-3">
    <div className="h-9 w-9 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${color}18`, color }}>
      <Icon className="h-5 w-5" aria-hidden="true" />
    </div>
    <div className="min-w-0">
      <div className="font-display font-semibold text-base leading-tight">{title}</div>
      {subtitle && <div className="text-xs text-muted-foreground truncate">{subtitle}</div>}
    </div>
  </div>
);

export const Row = ({ Icon, title, description, control, testId }) => (
  <div className="flex items-start gap-3 py-3 border-b border-border last:border-b-0" data-testid={testId}>
    <div className="h-9 w-9 rounded-lg bg-secondary/60 flex items-center justify-center flex-shrink-0 text-foreground/80">
      <Icon className="h-4 w-4" aria-hidden="true" />
    </div>
    <div className="flex-1 min-w-0">
      <div className="text-sm font-semibold text-foreground">{title}</div>
      {description && <div className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{description}</div>}
    </div>
    <div className="flex-shrink-0">{control}</div>
  </div>
);

const TEXT_SCALE_OPTIONS = [
  { v: 100, label: 'A' },
  { v: 115, label: 'A+' },
  { v: 130, label: 'A++' },
  { v: 150, label: 'A+++' },
];

const MOTION_OPTIONS = [
  { v: 'auto', label: 'Auto' },
  { v: 'always', label: 'Sempre' },
  { v: 'never', label: 'Mai' },
];

/** Generic pill radio-group used by both text-scale and motion controls. */
const PillRadioGroup = ({ value, onChange, options, ariaLabel, testPrefix, pillClass }) => (
  <div className="inline-flex items-center gap-1 p-1 rounded-full bg-secondary/60" role="radiogroup" aria-label={ariaLabel}>
    {options.map((o) => {
      const active = value === o.v;
      return (
        <button
          key={o.v}
          type="button"
          onClick={() => onChange(o.v)}
          role="radio"
          aria-checked={active}
          data-testid={`${testPrefix}-${o.v}`}
          className={`${pillClass} h-8 rounded-full text-xs font-semibold transition-colors ${active ? 'bg-primary text-primary-foreground shadow-sm' : 'text-foreground hover:bg-secondary'}`}
        >
          {o.label}
        </button>
      );
    })}
  </div>
);

export const TextScaleControl = ({ value, onChange }) => (
  <PillRadioGroup value={value} onChange={onChange} options={TEXT_SCALE_OPTIONS} ariaLabel="Dimensione testo" testPrefix="a11y-text-scale" pillClass="min-w-[38px] px-2" />
);

export const MotionControl = ({ value, onChange }) => (
  <PillRadioGroup value={value} onChange={onChange} options={MOTION_OPTIONS} ariaLabel="Riduci animazioni" testPrefix="a11y-motion" pillClass="px-3" />
);
